"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Warning = void 0;
const mobx_1 = require("mobx");
const print_util_1 = require("../../print-util");
/**
 * Page 6
 * - Warning label
 */
class Warning extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            var _a, _b;
            const { claim, barcode, patientSignature, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const order = currentClaim.order;
            const inventoryItem = (_a = historic === null || historic === void 0 ? void 0 : historic.inventoryData) !== null && _a !== void 0 ? _a : currentClaim.inventory;
            const patient = (_b = historic === null || historic === void 0 ? void 0 : historic.patientData) !== null && _b !== void 0 ? _b : order.patient;
            const patientGender = patient.gender === "1" ? "Male" : "Female";
            const pageBreak = this.lastPage ? "" : "after";
            return [
                {
                    margin: [0, 0, 0, 20],
                    layout: "noBorders",
                    table: {
                        widths: [120, 120],
                        headerRows: 1,
                        body: [
                            [
                                {
                                    stack: [
                                        `${patient.lastName || ""} ${patient.firstName || ""}`,
                                        `${patient.address || ""}, ${patient.city ||
                                            ""} ${patient.state || ""} ${patient.zip || ""}`,
                                        `DOB: ${patient.birthDate || ""}`,
                                        `Gender: ${patientGender || ""}`
                                    ],
                                    fontSize: 8
                                },
                                { image: barcode, width: 75 }
                            ]
                        ]
                    }
                },
                {
                    style: "tableText",
                    stack: [
                        `Important: Please review these important instructions and medication warnings about the medication being dispensed to you. These are summaries and do NOT have all possible information about these products. This information is not individual medical advice and does not substitute for the advice of your health care professional. Always ask your health care professional for complete information about these products and your specific health needs.`,
                        {
                            text: "Call your doctor for medical advice about side effects. You may report side effects to the FDA at 1-800-FDA-1088.",
                            bold: true,
                            margin: [0, 10, 0, 15]
                        },
                        {
                            text: `These instructions are specifically for ${patient.firstName ||
                                ""} ${patient.lastName ||
                                ""}. If this is not you, please disregard these instructions and contact your health care professional.`,
                            // bold: true,
                            margin: [0, 0, 0, 15]
                        }
                    ]
                },
                {
                    text: "Medication Instructions / Warnings / Counseling",
                    fontSize: 16,
                    alignment: "center"
                },
                {
                    style: "tableText",
                    stack: [
                        {
                            text: `Rx # ${claim.rxId.rxId || ""}-${claim.fillNumber} ${inventoryItem.package || ""}: ${
                            // inventoryItem.name
                            inventoryItem.name || inventoryItem.strengthDescription || ""}`,
                            bold: true
                        },
                        {
                            ul: [
                                `${inventoryItem.defaultSig
                                    ? "Instructions: " + inventoryItem.defaultSig
                                    : ""}`,
                                `${inventoryItem.defaultSig2
                                    ? "Instructions: " + inventoryItem.defaultSig2
                                    : ""}`,
                                `${inventoryItem.defaultSig3
                                    ? "Instructions: " + inventoryItem.defaultSig3
                                    : ""}`
                            ]
                        },
                        {
                            text: `Do you require additional counseling for this medication: ${order.reqCounsel ? "YES" : "NO"}`,
                            bold: true,
                            margin: [0, 10, 0, 0]
                        }
                    ],
                    // text: {
                    //     text: 'Do you requiire any additional counseling (Circle one)    YES / NO',
                    //     bold: true,
                    //     margin: [0, 10, 0, 0],
                    // },
                    margin: [0, 0, 0, 50]
                },
                {
                    image: patientSignature,
                    width: 100,
                    relativePosition: { x: 75, y: 5 }
                },
                {
                    style: "prescriberAgent",
                    text: `Patient Signature:                                                        , Date: ${this.orderCreateDate(order.createDate)} `,
                    alignment: "left",
                    relativePosition: { x: 0, y: 15 },
                    pageBreak
                }
            ];
        };
    }
}
exports.Warning = Warning;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/warning/warning.ts
// module id = 2749
// module chunks = 0 1